import * as React from "react";
import HostGrid from "./Host/HostGrid";
import PhoneSexAdvertisements from "./Phonesex/PhoneSexAdvertisements";
import Pagination from "./Pagination/Pagination";
import SeoFooter from "./WebmasterKit/SeoFooter";
function Grid(_a) {
  var page = _a.page;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HostGrid, {
    page: page
  }), /*#__PURE__*/React.createElement("div", {
    className: "clear"
  }), /*#__PURE__*/React.createElement(Pagination, {
    page: page
  }), /*#__PURE__*/React.createElement(PhoneSexAdvertisements, null), /*#__PURE__*/React.createElement("div", {
    className: "prodwidth l-container h-center"
  }, /*#__PURE__*/React.createElement(SeoFooter, {
    text: window.layoutSettings.seo.home.footer.text
  })));
}
export default Grid;